<app-call-waiter-indicator
  type="main"
  class="bell"
/>

@if (callWaiterMain()) {
  <div class="info">
    <span>Your server has been called and will be there shortly.</span>
    <span class="sub">Tap to cancel.</span>
  </div>
} @else {
  <span class="text">Call Server</span>
  <img src="/images/arrow-with-border.svg" alt="arrow right" height="56" width="56">
}
